module.exports = {
  selDep: {
    title: "轮转科室",
    noLoginRequired: true,
    requiredParams: {},
    optionalParams: {}
  },
  addTrainingRecord: {
    title: "",
    noLoginRequired: true,
    requiredParams: {
      id: "科室id",
      name: "科室名称"
    },
    optionalParams: {}
  },
  recordList: {
    title: "已填写记录",
    noLoginRequired: true,
    requiredParams: {
      id: "科室id",
      name: "科室名称"
    },
    optionalParams: {}
  },
  formRecord: {
    title: "填写记录",
    noLoginRequired: true,
    requiredParams: {
      id: "表单记录id"
      // name: "科室名称"
    },
    optionalParams: {}
  }
};
